export default __webpack_public_path__ + "static/media/ii.e9ac5440.png";